<template>
  <div class="project-sum">
    <div class="project-sum-title">{{ $t('projectSum.title') }}</div>
    <div class="table-center">
      <div class="table-scroll">
        <el-row class="row-border-1">
          <el-col :span="24" class="padding10">
            <div class="text-center font-weight">
            {{localeValue(competitionSumInfo, competitionNameKey)}}-{{teamInfoVo.teamName}}{{$t('projectSum.registrationForm')}}
          </div>
        </el-col>
      </el-row>
        <!--队伍信息-->
      <el-row class="row-border-1" v-if="teamColumns.length > 0">
        <el-col :span="24" class="padding10 bg-eeecec">
          <div class="text-center font-weight">{{ $t('projectSum.teamInfo') }}</div>
        </el-col>
      </el-row>
      <el-row class="row-border-1" v-if="teamColumns.length > 0">
        <el-col v-for="(col, index) in teamColumns" :key="col.key" :span="col.span"
                :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
          <div class="text-center font-weight">{{ col.label }}</div>
        </el-col>
      </el-row>
      <el-row class="row-border-1" v-if="teamColumns.length > 0">
        <el-col v-for="(col, index) in teamColumns" :key="col.key + '-value'" :span="col.span"
                :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
          <div class="text-center word-break">{{ teamInfoVo[col.prop] }}</div>
        </el-col>
      </el-row>
              <!--运动员信息-->
      <el-row class="row-border-1" v-if="athleteColumns.length > 0">
        <el-col :span="24" class="padding10 bg-eeecec">
          <div class="text-center font-weight">{{ $t('projectSum.athleteInfo') }}</div>
        </el-col>
      </el-row>
      <el-row class="row-border-1" v-if="athleteColumns.length > 0">
        <el-col v-for="(col, index) in athleteColumns" :key="col.key" :span="col.span"
                :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
          <div class="text-center font-weight">{{ col.label }}</div>
        </el-col>
      </el-row>
      <div v-for="athlete in competitionSumInfo.athleteList" :key="athlete.id">
        <el-row class="row-border-1">
          <el-col v-for="(col, index) in athleteColumns" :key="col.key" :span="col.span"
                  :class="index === 0 ? '' : 'cell-border-f'">
            <div class="text-center cell-image">
              <el-image v-if="col.type === 'image'"
                        style="width: auto; height: 40px"
                        :src="define.previewNginxUrl + athlete[col.prop]"
                        :preview-src-list="[define.previewNginxUrl + athlete[col.prop]]">
              </el-image>
              <span v-else>{{ formatCellValue(athlete, col) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
        <!--随队官员-->
      <el-row class="row-border-1" v-if="personColumns.length > 0">
        <el-col :span="24" class="padding10 bg-eeecec">
          <div class="text-center font-weight">{{ $t('projectSum.officialInfo') }}</div>
        </el-col>
      </el-row>
      <el-row class="row-border-1" v-if="personColumns.length > 0">
        <el-col v-for="(col, index) in personColumns" :key="col.key" :span="col.span"
                :class="index === 0 ? 'padding10' : 'cell-border-f padding10'">
          <div class="text-center font-weight">{{ col.label }}</div>
        </el-col>
      </el-row>
      <div v-for="person in competitionSumInfo.personList" :key="person.id">
        <el-row class="row-border-1">
          <el-col v-for="(col, index) in personColumns" :key="col.key" :span="col.span"
                  :class="index === 0 ? '' : 'cell-border-f'">
            <div class="text-center cell-image">
              <el-image v-if="col.type === 'image'"
                        style="width: auto; height: 40px"
                        :src="define.previewNginxUrl + person[col.prop]"
                        :preview-src-list="[define.previewNginxUrl + person[col.prop]]">
              </el-image>
              <span v-else>{{ formatCellValue(person, col) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
        <!--个人项目-->
      <template v-if="showProjectType('1')">
        <el-row class="row-border-1">
          <el-col :span="24" class="padding10 bg-eeecec">
            <div class="text-center font-weight">{{ $t('common.individualProject') }}</div>
          </el-col>
        </el-row>
        <div v-for="(personProjects, key) in competitionSumInfo.personProjectList" :key="'personProject-' + key">
          <el-row class="row-border-1">
            <el-col :span="5" class="padding10">
              <div class="text-center">{{localeValue(personProjects, projectNameKey)}}</div>
            </el-col>
            <el-col :span="19" class="cell-border-f padding10">
              <div class="">
                <span v-for="(personProject, index) in personProjects.teamAthleteList" :key="personProject.id">
                  <span v-if="index === 0">{{localeValue(personProject, competitionAthleteNameKey)}}</span>
                  <span v-else>、{{localeValue(personProject, competitionAthleteNameKey)}}</span>
                   <span v-if="personProject.description">（{{ remarkLabel }}：{{personProject.description}}）</span>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
        <!--集体项目-->
      <template v-if="showProjectType('2')">
        <el-row class="row-border-1">
          <el-col :span="24" class="padding10 bg-eeecec">
            <div class="text-center font-weight">{{ $t('common.groupProject') }}</div>
          </el-col>
        </el-row>
        <div v-for="(teamProjects, key) in competitionSumInfo.teamProjectList" :key="'teamProject-' + key">
          <el-row class="row-border-1">
            <el-col :span="5" class="padding10">
              <div class="text-center">{{localeValue(teamProjects, projectNameKey)}}</div>
            </el-col>
            <el-col :span="19" class="cell-border-f padding10">
              <div class="">
                <span v-for="(teamProject, index) in teamProjects.teamAthleteList" :key="teamProject.id">
                  <span v-if="index === 0">{{localeValue(teamProject, competitionAthleteNameKey)}}{{localeValue(teamProject, itemPositionNameKey) ? '（' + $t('common.position') + '：' + localeValue(teamProject, itemPositionNameKey) + '）' : ''}}{{teamProject.substitution === 1 ? '（' + $t('common.substitute') + '）' : ''}}</span>
                  <span v-else>、{{localeValue(teamProject, competitionAthleteNameKey)}}{{localeValue(teamProject, itemPositionNameKey) ? '（' + $t('common.position') + '：' + localeValue(teamProject, itemPositionNameKey) + '）' : ''}}{{teamProject.substitution === 1 ? '（' + $t('common.substitute') + '）' : ''}}</span>
                </span>
                <span v-if="teamProjects.teamAthleteList[0] && teamProjects.teamAthleteList[0].description">（{{ remarkLabel }}：{{ teamProjects.teamAthleteList[0].description}}）</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
        <!--对练项目-->
      <template v-if="showProjectType('3')">
        <el-row class="row-border-1">
          <el-col :span="24" class="padding10 bg-eeecec">
            <div class="text-center font-weight">{{ $t('common.pairTrainingProject') }}</div>
          </el-col>
        </el-row>
        <div v-for="(trainProjects, key) in competitionSumInfo.trainProjectList" :key="'trainProject-' + key">
          <el-row class="row-border-1">
            <el-col :span="5" class="padding10">
              <div class="text-center">{{localeValue(trainProjects, projectNameKey)}}</div>
            </el-col>
            <el-col :span="19" class="cell-border-f padding10">
              <div class="">
                <div v-for="(trainValue, trainKey, index) in trainProjects.trainAthleteList" :key="trainKey">
                  {{index+1}}、
                  <span v-for="(trainItem, index) in trainValue" :key="trainItem.id" style="width: 100%">
                    <span v-if="index === 0">{{localeValue(trainItem, competitionAthleteNameKey)}}</span>
                    <span v-else>、{{localeValue(trainItem, competitionAthleteNameKey)}}</span>
                    <span v-if="trainItem.practice === 1">（{{ $t('common.trainingPartner') }}）</span>
                  </span>
                  <span v-if="trainValue[0] && trainValue[0].description">（{{ remarkLabel }}：{{trainValue[0].description }}）</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
        <!--统计信息-->
      <el-row class="row-border-1">
        <el-col :span="24" class="padding10 bg-eeecec">
          <div class="text-center font-weight">{{ $t('common.statistics') }}</div>
        </el-col>
      </el-row>
      <el-row class="row-border-1">
        <el-col :span="4" class="padding10">
          <div class="text-center font-weight">{{ $t('common.totalPeople') }}</div>
        </el-col>
        <el-col :span="4" class="cell-border-f padding10">
          <div class="text-center font-weight">{{ $t('common.male') }}</div>
        </el-col>
        <el-col :span="4" class="cell-border-f padding10">
          <div class="text-center font-weight">{{ $t('common.female') }}</div>
        </el-col>
        <el-col :span="4" class="cell-border-f padding10">
          <div class="text-center font-weight">{{ $t('common.athlete') }}</div>
        </el-col>
        <el-col :span="4" class="cell-border-f padding10">
          <div class="text-center font-weight">{{ $t('common.maleAthlete') }}</div>
        </el-col>
        <el-col :span="4" class="cell-border-f padding10">
          <div class="text-center font-weight">{{ $t('common.femaleAthlete') }}</div>
        </el-col>
      </el-row>
      <el-row class="row-border-1">
        <el-col :span="4" class="cell-border-b padding10">
          <div class="text-center">{{personStaVo.sumNum}} {{$t('common.people')}}</div>
        </el-col>
        <el-col :span="4" class="cell-border-fb padding10">
          <div class="text-center">{{personStaVo.maleNum}} {{$t('common.people')}}</div>
        </el-col>
        <el-col :span="4" class="cell-border-fb padding10">
          <div class="text-center">{{personStaVo.femaleNum}} {{$t('common.people')}}</div>
        </el-col>
        <el-col :span="4" class="cell-border-fb padding10">
          <div class="text-center">{{personStaVo.athleteNum}} {{$t('common.people')}}</div>
        </el-col>
        <el-col :span="4" class="cell-border-fb padding10">
          <div class="text-center">{{personStaVo.maleAthleteNum}} {{$t('common.people')}}</div>
        </el-col>
        <el-col :span="4" class="cell-border-fb padding10">
          <div class="text-center">{{personStaVo.femaleAthleteNum}} {{$t('common.people')}}</div>
        </el-col>
      </el-row>
      <div class="upload-section">
        <div v-if="showField('reportFileJson')" class="upload-item">
          <el-upload
              :action="define.uploadUrl2 + 'images'"
              :headers="uploadHeaders"
              :data="{fileName: uploadFileName('reportFileJson'), competitionId: competitionId}"
              accept="image/*,.pdf"
              :show-file-list="true"
              :file-list="reportFileList"
              :on-success="handleReportFileSuccess"
              :before-upload="beforeReportFileUpload"
              :on-remove="handleReportFileRemove"
          >
            <el-button type="primary" :disabled="isTeamSubmitted">{{ $t('projectSum.uploadStampedForm') }}</el-button>
          </el-upload>
        </div>
        <div v-if="showField('responsibilityFileJson')" class="upload-item">
          <el-upload
              :action="define.uploadUrl2 + 'images'"
              :headers="uploadHeaders"
              :data="{fileName: uploadFileName('responsibilityFileJson'), competitionId: competitionId}"
              accept="image/*,.pdf"
              :show-file-list="true"
              :file-list="responsibilityFileList"
              :on-success="handleResponsibilityFileSuccess"
              :before-upload="beforeResponsibilityFileUpload"
              :on-remove="handleResponsibilityFileRemove"
          >
            <el-button type="primary" :disabled="isTeamSubmitted">{{ $t('projectSum.uploadVoluntaryLiability') }}</el-button>
          </el-upload>
        </div>
      </div>
      </div>
      <div class="button-row">
        <el-button type="primary" @click="toDownload()" :loading="downloadLoading" :disabled="isTeamSubmitted">{{ $t('projectSum.downloadForm') }}</el-button>
        <el-button type="primary" @click="toSubmit()" :loading="submitLoading" v-if="teamInfoVo.status === 1">{{ $t('common.submit') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {competitionSumInfo} from "@/api/competition";
import {submitTeamInfo} from "@/api/team";
import {compressImage} from "@/util/image";
export default {
  name: "project-sum",
  props: {
    teamInfo: {
      type: Object,
      required: true
    },
    competitionFormConfigInfo: {
      type: Object,
      default: function () {
        return {
          id: '',
          competitionId: '',
          teamForm: {},
          athleteForm: {},
          personForm: {},
          summaryForm: {}
        }
      }
    }
  },
  computed: {
    // 备注标题（报项表单配置，留空默认备注）
    remarkLabel() {
      const remarkLabel = (this.competitionFormConfigInfo.projectForm || {}).remarkLabel;
      return remarkLabel || this.$t('common.comment');
    },
    // 是否显示字段
    showField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.summaryForm[fieldName];
        return fieldConfig && fieldConfig.isShow === 1;
      };
    },
    // 字段标签
    labelField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.summaryForm[fieldName];
        return fieldConfig && fieldConfig.label;
      };
    },
    // 提交提示
    submitTip() {
      const fieldConfig = (this.competitionFormConfigInfo.summaryForm || {}).submitTipJson;
      return (fieldConfig && fieldConfig.isShow === 1 && fieldConfig.content) ? fieldConfig.content : '';
    },
    // 运动员字段标签
    labelAthleteField() {
      return (fieldName) => {
        const fieldConfig = (this.competitionFormConfigInfo.athleteForm || {})[fieldName];
        return fieldConfig && fieldConfig.label;
      };
    },
    // 随队官员字段标签
    labelPersonField() {
      return (fieldName) => {
        const fieldConfig = (this.competitionFormConfigInfo.personForm || {})[fieldName];
        return fieldConfig && fieldConfig.label;
      };
    },
    // 显示项目类型区块（1=个人项目 2=集体项目 3=对练项目）
    showProjectType() {
      return (fieldType) => {
        const competitionForm = this.competitionFormConfigInfo.competitionForm;
        if (!competitionForm) return false;
        const fieldConfig = competitionForm.projectTypeJson;
        return fieldConfig && fieldConfig.checkedOptions && fieldConfig.checkedOptions.includes(fieldType);
      };
    },
    // 代表队信息动态列（显示/隐藏、汇总表宽度取自队伍表单配置）
    teamColumns() {
      const defs = [
        {key: 'realNameJson', prop: 'realName', label: this.$t('teamInfo.contactName')},
        {key: 'mobileJson', prop: 'mobile', label: this.$t('common.contactPhone')},
        {key: 'emailJson', prop: 'email', label: this.$t('common.contactEmail')},
        {key: 'memberUnitJson', prop: 'memberUnitNameCh', label: this.$t('teamInfo.memberUnit')},
        {key: 'regionJson', prop: 'regionNameCh', label: this.$t('teamInfo.region')},
      ];
      return this.summaryColumns('teamForm', defs);
    },
    // 运动员信息动态列（显示/隐藏、汇总表宽度取自运动员表单配置）
    athleteColumns() {
      const defs = [
        {key: 'realNameChJson', prop: 'realNameCh', label: this.labelAthleteField('realNameChJson')},
        {key: 'realNameEnJson', prop: 'realNameEn', label: this.$t('athleteInfo.realNameEn')},
        {key: 'familyNameChJson', prop: 'familyNameCh', label: this.$t('athleteInfo.surnameCh')},
        {key: 'familyNameEnJson', prop: 'familyNameEn', label: this.$t('athleteInfo.surnameEn')},
        {key: 'givenNameChJson', prop: 'givenNameCh', label: this.$t('athleteInfo.givenNameCh')},
        {key: 'givenNameEnJson', prop: 'givenNameEn', label: this.$t('athleteInfo.givenNameEn')},
        {key: 'certificateTypeJson', prop: 'certificateType', label: this.$t('common.certificateType'), type: 'certificateType'},
        {key: 'certificateNumberJson', prop: 'certificateNumber', label: this.$t('common.certificateNumber')},
        {key: 'genderJson', prop: 'gender', label: this.$t('common.gender'), type: 'gender'},
        {key: 'ageJson', prop: 'age', label: this.$t('common.age')},
        {key: 'birthdayJson', prop: 'birthday', label: this.$t('common.birthDate')},
        {key: 'groupJson', prop: this.competitionGroupNameKey, label: this.$t('common.group')},
        {key: 'headIconJson', prop: 'headIcon', label: this.$t('common.headPhoto'), type: 'image'},
        {key: 'certificateFrontalPhotoJson', prop: 'certificateFrontalPhoto', label: this.$t('common.certificateFrontPhoto'), type: 'image'},
        {key: 'certificateReversePhotoJson', prop: 'certificateReversePhoto', label: this.$t('common.certificateBackPhoto'), type: 'image'},
        {key: 'mobileJson', prop: 'mobile', label: this.$t('common.contactPhone')},
        {key: 'emailJson', prop: 'email', label: this.$t('common.contactEmail')},
        {key: 'customText1Json', prop: 'customText1', label: this.labelAthleteField('customText1Json')},
        {key: 'customText2Json', prop: 'customText2', label: this.labelAthleteField('customText2Json')},
        {key: 'customText3Json', prop: 'customText3', label: this.labelAthleteField('customText3Json')},
        {key: 'customFile1Json', prop: 'customFile1', label: this.labelAthleteField('customFile1Json'), type: 'image'},
        {key: 'customFile2Json', prop: 'customFile2', label: this.labelAthleteField('customFile2Json'), type: 'image'},
        {key: 'customFile3Json', prop: 'customFile3', label: this.labelAthleteField('customFile3Json'), type: 'image'},
      ];
      return this.summaryColumns('athleteForm', defs);
    },
    // 随队官员信息动态列（显示/隐藏、汇总表宽度取自随队官员表单配置）
    personColumns() {
      const defs = [
        {key: 'realNameChJson', prop: 'realNameCh', label: this.labelPersonField('realNameChJson')},
        {key: 'realNameEnJson', prop: 'realNameEn', label: this.$t('personInfo.realNameEn')},
        {key: 'familyNameChJson', prop: 'familyNameCh', label: this.$t('personInfo.surnameCh')},
        {key: 'familyNameEnJson', prop: 'familyNameEn', label: this.$t('personInfo.surnameEn')},
        {key: 'givenNameChJson', prop: 'givenNameCh', label: this.$t('personInfo.givenNameCh')},
        {key: 'givenNameEnJson', prop: 'givenNameEn', label: this.$t('personInfo.givenNameEn')},
        {key: 'certificateTypeJson', prop: 'certificateType', label: this.$t('common.certificateType'), type: 'certificateType'},
        {key: 'certificateNumberJson', prop: 'certificateNumber', label: this.$t('common.certificateNumber')},
        {key: 'genderJson', prop: 'gender', label: this.$t('common.gender'), type: 'gender'},
        {key: 'ageJson', prop: 'age', label: this.$t('common.age')},
        {key: 'birthdayJson', prop: 'birthday', label: this.$t('common.birthDate')},
        {key: 'groupJson', prop: this.competitionGroupNameKey, label: this.$t('common.group')},
        {key: 'itemJson', prop: this.competitionItemNameKey, label: this.$t('common.item')},
        {key: 'headIconJson', prop: 'headIcon', label: this.$t('common.headPhoto'), type: 'image'},
        {key: 'certificateFrontalPhotoJson', prop: 'certificateFrontalPhoto', label: this.$t('common.certificateFrontPhoto'), type: 'image'},
        {key: 'certificateReversePhotoJson', prop: 'certificateReversePhoto', label: this.$t('common.certificateBackPhoto'), type: 'image'},
        {key: 'mobileJson', prop: 'mobile', label: this.$t('common.contactPhone')},
        {key: 'emailJson', prop: 'email', label: this.$t('common.contactEmail')},
        {key: 'functionJson', prop: this.competitionFunctionNameKey, label: this.$t('common.function')},
        {key: 'customText1Json', prop: 'customText1', label: this.labelPersonField('customText1Json')},
        {key: 'customText2Json', prop: 'customText2', label: this.labelPersonField('customText2Json')},
        {key: 'customText3Json', prop: 'customText3', label: this.labelPersonField('customText3Json')},
        {key: 'customFile1Json', prop: 'customFile1', label: this.labelPersonField('customFile1Json'), type: 'image'},
        {key: 'customFile2Json', prop: 'customFile2', label: this.labelPersonField('customFile2Json'), type: 'image'},
        {key: 'customFile3Json', prop: 'customFile3', label: this.labelPersonField('customFile3Json'), type: 'image'},
      ];
      return this.summaryColumns('personForm', defs);
    },
    // 赛事名称中英文
    competitionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事组别名称中英文
    competitionGroupNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'groupNameCh' : 'groupNameEn';
    },
    // 赛事小项名称中英文
    competitionItemNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'itemNameCh' : 'itemNameEn';
    },
    // 赛事运动员姓名中英文
    competitionAthleteNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'athleteRealNameCh' : 'athleteRealNameEn';
    },
    // 集体项目运动员职位名称中英文
    itemPositionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'itemPositionNameCh' : 'itemPositionNameEn';
    },
    // 项目名称中英文
    projectNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事职能名称中英文
    competitionFunctionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'functionNameCh' : 'functionNameEn';
    },
  },
  data() {
    return {
      // 文件上传token
      uploadHeaders: {Authorization: localStorage.getItem("token")},
      // 汇总信息
      competitionSumInfo: {},
      // 代表队信息
      teamInfoVo: {
        id: '',
        userId: '',
        competitionId: '',
        teamName: '',
        realName: '',
        email: '',
        mobile: '',
        reportFile: '',
        responsibilityFile: '',
        status: '',
        submitTime: '',
      },
      // 赛事ID
      competitionId: '',
      // 汇总统计
      personStaVo: {},
      // 下载loading
      downloadLoading: false,
      // 报名表
      reportFileList: [],
      // 自愿参赛责任书
      responsibilityFileList: [],
      // 提交loading
      submitLoading: false,
    }
  },
  created() {
    let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.competitionId = id;
    }
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login?id=" + this.competitionId });
    } else {
      this.findCompetitionSumInfo();
    }
  },
  destroyed() {},
  methods: {
    // 获取赛事信息
    findCompetitionSumInfo(){
      let params = {
        type: 1,
        competitionId: this.competitionId,
      };
      competitionSumInfo(params).then((res) => {
        this.competitionSumInfo = res.data;
        if (res.data.teamInfoVo) {
          this.teamInfoVo = res.data.teamInfoVo;
          if (this.teamInfoVo.reportFile) {
            this.reportFileList = [{name: this.teamInfoVo.reportFile}]
          }
          if (this.teamInfoVo.responsibilityFile) {
            this.responsibilityFileList = [{name: this.teamInfoVo.responsibilityFile}]
          }
        }
        this.personStaVo = res.data.personStaVo;
      });
    },
    // 根据表单配置生成汇总表动态列（isShow控制显示，span为汇总表宽度）
    summaryColumns(formName, defs) {
      const formConfig = this.competitionFormConfigInfo[formName] || {};
      const columns = [];
      defs.forEach(def => {
        const fieldConfig = formConfig[def.key];
        if (fieldConfig && fieldConfig.isShow === 1) {
          columns.push({
            key: def.key,
            prop: def.prop,
            label: def.label,
            type: def.type || 'text',
            span: fieldConfig.span && fieldConfig.span > 0 ? fieldConfig.span : 4, // span未配置或为0时按1/6宽度兜底，避免列被压没
          });
        }
      });
      return columns;
    },
    // 汇总表单元格文本
    formatCellValue(row, col) {
      const value = this.localeValue(row, col.prop);
      if (col.type === 'gender') {
        return value === 1 ? this.$t('common.male') : this.$t('common.female');
      }
      if (col.type === 'certificateType') {
        return this.certificateTypeText(value);
      }
      return value === null || value === undefined ? '' : value;
    },
    // 证件类型文本
    certificateTypeText(value) {
      const labelMap = {
        1: 'common.idCard',
        2: 'common.drivingLicense',
        3: 'common.passport',
        4: 'common.militaryCard',
        5: 'common.hkMacauId',
        6: 'common.taiwanPermit',
        7: 'common.other'
      };
      return labelMap[value] ? this.$t(labelMap[value]) : '';
    },
    // 下载报名表
    toDownload(){
      let url = window.g.VIEW_URL + "/printPdf?id=" + this.competitionId + "&type=1";
      window.open(url);
    },
    // 报名表上传成功
    handleReportFileSuccess(res) {
      this.teamInfoVo.reportFile = res.data.url;
      this.reportFileList = [{name: res.data.url}]
    },
    // 报名表上传时
    beforeReportFileUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isPDF = file.type === 'application/pdf';
      const isAllowed = isImage || isPDF;

      if (!isAllowed) {
        this.$message.error(this.$t('projectSum.onlyImageOrPdf'));
        return false;
      }
      // 图片压缩至200KB以内后替换原文件上传，PDF原样上传
      return compressImage(file);
    },
    // 上传文件名：队伍名称_字段名称(表单配置label，为空回退字段标识)
    uploadFileName(configKey) {
      const fieldConfig = (this.competitionFormConfigInfo.summaryForm || {})[configKey];
      const parts = [this.teamInfoVo.teamName, (fieldConfig && fieldConfig.label) || configKey].filter(part => part);
      return parts.join('_');
    },
    // 报名表移除
    handleReportFileRemove(file, fileList) {
      this.teamInfoVo.reportFile = '';
      this.reportFileList = []
    },
    // 自愿参赛责任书上传成功
    handleResponsibilityFileSuccess(res) {
      this.teamInfoVo.responsibilityFile = res.data.url;
      this.responsibilityFileList = [{name: res.data.url}]
    },
    // 自愿参赛责任书上传时
    beforeResponsibilityFileUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isPDF = file.type === 'application/pdf';
      const isAllowed = isImage || isPDF;

      if (!isAllowed) {
        this.$message.error(this.$t('projectSum.onlyImageOrPdf'));
        return false;
      }
      // 图片压缩至200KB以内后替换原文件上传，PDF原样上传
      return compressImage(file);
    },
    // 自愿参赛责任书移除
    handleResponsibilityFileRemove(file, fileList) {
      this.teamInfoVo.responsibilityFile = '';
      this.responsibilityFileList = []
    },
    // 提交
    toSubmit(){
      // 校验附件并提交
      const doSubmit = () => {
        if (this.showField('reportFileJson')) {
          if (!this.teamInfoVo.reportFile) {
            this.$message.error(this.$t('projectSum.needUploadForm'));
            return;
          }
        }
        if (this.showField('responsibilityFileJson')) {
          if (!this.teamInfoVo.responsibilityFile) {
            this.$message.error(this.$t('projectSum.needUploadLiability'));
            return;
          }
        }
        let dataForm = {
          competitionId: this.competitionId,
          reportFile: this.teamInfoVo.reportFile,
          responsibilityFile: this.teamInfoVo.responsibilityFile,
        }
        this.submitLoading = true;
        submitTeamInfo(dataForm).then((res) => {
          if (res.code === 200) {
            this.teamInfoVo.status = 2;
            this.$emit('updateTeamStatus', 2);
            this.$message.success(res.msg);
            this.submitLoading = false;
          } else {
            this.$message.error(res.msg);
            this.submitLoading = false;
          }
        });
      };
      // 汇总表单配置启用提交提示时弹出配置内容，未启用时直接提交
      if (this.submitTip) {
        this.$confirm(this.submitTip, this.$t('common.prompt'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: "warning",
        }).then(() => {
          doSubmit();
        }).catch(() => {
        });
      } else {
        doSubmit();
      }
    }
  }
}
</script>
<style scoped lang="scss">

.project-sum{
  width: 100%;

  .project-sum-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    padding-bottom: 12px;
    margin-bottom: 20px;
    border-bottom: 2px solid #1E50AE;
  }

  .table-center {
    height: calc(100vh - 300px);
    margin-top: 10px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    padding: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;

    .row-border-1 {
      display: flex;
      // 列拉伸到整行高，竖向边框才不会被换行撑高的行截短；列内用flex保持内容垂直居中
      align-items: stretch;
      flex-wrap: wrap;
      border-top: 1px solid #dcdcdc;
      border-left: 1px solid #dcdcdc;
      border-right: 1px solid #dcdcdc;
      transition: background-color 0.15s;

      > .el-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .cell-border-f {
      border-left: 1px solid #dcdcdc;
      box-sizing: border-box;
    }

    .cell-border-fb {
      border-left: 1px solid #dcdcdc;
      border-bottom: 1px solid #dcdcdc;
      box-sizing: border-box;
    }

    .cell-border-b {
      border-bottom: 1px solid #dcdcdc;
      box-sizing: border-box;
    }

    .text-center{
      text-align: center;
    }

    .font-weight {
      font-weight: bold;
      color: #303133;
    }

    .word-break{
      word-break: break-all;
    }

    .cell-image{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      word-break: break-all;
    }

    .padding10 {
      padding: 10px;
    }

    .bg-eeecec {
      background: #f0f2f5;
      padding: 12px 10px;
      border-left: 4px solid #409eff;
    }

    .table-scroll {
      flex: 1;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background: #c0c4cc;
        border-radius: 3px;
      }

      .upload-section {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 16px 0 8px;

        .upload-item {
          display: inline-flex;
        }
      }
    }

    .button-row {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
      padding-top: 12px;
      flex-shrink: 0;
      border-top: 1px solid #ebeef5;
    }
  }
}
</style>
